import { render, staticRenderFns } from "./StoreLinked.vue?vue&type=template&id=2145dd48&"
import script from "./StoreLinked.vue?vue&type=script&lang=js&"
export * from "./StoreLinked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports